export const dateFormat = 'DD/MM/YYYY';


type StatusColors = {
    [key: string]: string;
}

export const status_colors : StatusColors = {
    "RESTING": "#1BC5BD",
    "OTHER": "gray",
}
